import { Component, Input } from "@angular/core";
import { FundingTransactionOrderBy } from "@merchant_api/models/funding-transaction-order-by";
import { LocalTimePoint } from "shared-lib";

@Component({
    selector: "app-funding-item-transactions-table-cell-content",
    templateUrl: "./funding-item-transactions-table-cell-content.component.html",
    styleUrls: ["./funding-item-transactions-table-cell-content.component.less"],
    standalone: false
})
export class FundingItemTransactionsTableCellContentComponent {

    LocalTimePoint = LocalTimePoint;
    FundingTransactionOrderBy = FundingTransactionOrderBy;

    @Input() columnId: string;
    @Input() element: any;

    getDisplayTextForPayerName() {
        let displayText;
        if (this.element.payer?.fullName) {
            displayText = `${this.element.payer.fullName}`.toUpperCase();
        }
        return displayText;
    }

    getDisplayTextForCardNumber() {
        let displayText;
        if ((this.element.card?.first6) && (this.element.card?.last4)) {
            displayText = `${this.element.card.first6}XXX${this.element.card?.last4}`;
        }
        return displayText;
    }

    get displayTextForTransactionType() {
        let suffix = "";
        if (this.element.isServiceFee) {
            suffix = " (SF)";
        }
        return `${this.element.type}${suffix}`;
    }

}
